import angular from 'angular';
import passwordRecoveryConfig from './password-recovery.config';

import passwordRecovery from '../../containers/password-recovery';

const passwordRecoveryModule = angular.module('meredicte.passwordRecovery', [])
  .component('appPasswordRecovery', passwordRecovery)
  .config(passwordRecoveryConfig);

export default passwordRecoveryModule;



// WEBPACK FOOTER //
// ./src/modules/password-recovery/password-recovery.module.js